import { render, staticRenderFns } from "./BrbUploader.vue?vue&type=template&id=632ebf9c&"
import script from "./BrbUploader.vue?vue&type=script&lang=js&"
export * from "./BrbUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632ebf9c')) {
      api.createRecord('632ebf9c', component.options)
    } else {
      api.reload('632ebf9c', component.options)
    }
    module.hot.accept("./BrbUploader.vue?vue&type=template&id=632ebf9c&", function () {
      api.rerender('632ebf9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbUploader.vue"
export default component.exports